import React from "react";

import useStyles from "@hooks/useStyles";

import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Avatar from "@material-ui/core/Avatar";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import LineBreak from "@components/Global/Custom/Icons/LineBreak";

const WebsiteCardList = () => {
	const classes = useStyles("Website");

	const backgroundColor = ""; // #ffebe5
	const backgroundGradient = ``; // for testing  linear-gradient(121.04deg,#79dfff 15.69%,#865cff)
	const backgroundImage = ``; // for testing https://wallpapercave.com/wp/wp8377155.jpg
	const coloredBox = false;

	const header = `The Zen Kidz TX Team`;
	const subHeader = `Meet the team`;
	const tagline = "32 years experience";
	const textAlign = "left"; // left / center / right
	const lineBreak = true;
	const content =
		"Our Reggio Emilia-inspired curriculum, Creatively Shine®, is based on the latest research and trends to prepare your children for their educational careers equipping them with cognitive, social, emotional, physical and language skills.";

	const button = "";
	const buttonLink = "/wesbite/about-us";

	const buttonSecondary = "";
	const buttonSecondaryLink = "/wesbite/about-us";

	const items = [
		{
			image:
				"https://zenkidztx.com/wp-content/uploads/Julie-McConn-with-yoga-students.jpg",
			header: "Julie McConn",
			description:
				"Julie McConn has a master's degree in educational psychology from the University of Houston, and she was an elementary school teacher for eight years. She completed her 200-hour yoga teacher training through Shades of Yoga in Bali, Indonesia, and holds two kids' yoga certifications with both Rainbow Yoga and Cosmic Kids./n Julie has an undying love for travel, has visited more than 60 countries, and spent three years living overseas. She is most happy spending time outdoors with her daughter and husband, LOVES football, and considers watching stand-up comedy her favorite pastime./nShe feels passionately about working with kids and created her yoga and mindfulness curriculum to help children stay healthy in both mind and body in a fun and meaningful way.",
			buttonText: "Learn more",
			buttonLink: "/",
		},
		{
			image: "https://zenkidztx.com/wp-content/uploads/Serra.jpg",
			header: "Serra McConn",
			description:
				"Serra is from Istanbul, Turkey, and she moved to the United States in 2017. She is a psychology major on a pre-med track at the University of Houston! GO COOGS! She has always loved working with kids, and before she started teaching yoga, she taught kids swimming and tennis lessons. She loves yoga because it helps her manage her ADHD, and teaching yoga to kids allows her a happy break from the wildness of college n!",
			buttonText: "Learn more",
			buttonLink: "/",
		},
		{
			image:
				"https://ashleysplayhouseaustin.com/wp-content/uploads/2013/12/ashley2.jpg",
			header: "Ashley Pax",
			description:
				"Ashley Pax, the owner of Ashley’s Playhouse, has always had a vision to create a business that would allow her to engage with children on a daily basis. After getting her Masters in Accounting at the University of Texas at Austin, Ashley worked as an auditor for Ernst & Young for several years before becoming the Revenue Accountant at HomeAway.com here in Austin. In early 2013, Ashley decided it was time to pursue her dream and began plans to open Ashley’s Playhouse, a magical place that kids would love and parents can trust. In addition to her passion for working with children, Ashley is active in her church, enjoys spending time with family and friends and is an avid runner.",
			buttonText: "Learn more",
			buttonLink: "/",
		},
	];

	return (
		<React.Fragment>
			<section
				className={
					tagline || header || subHeader || lineBreak || content
						? "websiteComponent"
						: "websiteComponent thin"
				}
				style={{
					backgroundColor:
						!coloredBox && backgroundColor ? backgroundColor : "unset",
					backgroundImage:
						!coloredBox && backgroundGradient ? backgroundGradient : "unset",
				}}
			>
				{backgroundImage && (
					<Box
						position={"absolute"}
						top={0}
						bottom={0}
						width={"100%"}
						style={{
							backgroundImage: `url(${backgroundImage})`,
							backgroundRepeat: "no-repeat",
							backgroundSize: "cover",
							backgroundPosition: "50% 50%",
							opacity: "0.4",
							//filter: "blur(2px)",
						}}
						zIndex={1}
					/>
				)}

				<Container maxWidth={"lg"} disableGutters style={{ zIndex: 3 }}>
					<div
						className={coloredBox ? classes.featuredTextBox : undefined}
						style={{
							backgroundColor:
								coloredBox && backgroundColor ? backgroundColor : "",
							backgroundImage:
								coloredBox && backgroundGradient ? backgroundGradient : "unset",
						}}
					>
						<Grid
							container
							spacing={8}
							justifyContent="center"
							alignItems={
								textAlign === "left"
									? "flex-start"
									: textAlign === "right"
									? "flex-end"
									: "center"
							}
						>
							<Grid item xs={12}>
								<Box
									display={"flex"}
									flexDirection={"column"}
									justifyContent={"center"}
									alignItems={
										textAlign === "left"
											? "flex-start"
											: textAlign === "right"
											? "flex-end"
											: "center"
									}
									height={"100%"}
								>
									{tagline && (
										<Box className="tagline" textAlign={textAlign}>
											{tagline}
										</Box>
									)}

									{header && (
										<Box component={"h2"} textAlign={textAlign}>
											{header}
										</Box>
									)}

									{subHeader && (
										<Box component={"h3"} textAlign={textAlign}>
											{subHeader}
										</Box>
									)}

									{lineBreak && (
										<Box my={1} textAlign={textAlign}>
											<LineBreak className={classes.lineBreak} />
										</Box>
									)}

									{content && (
										<>
											<Box component={"p"} textAlign={textAlign}>
												{content}
											</Box>
										</>
									)}

									<Box mt={6}>
										<Grid container spacing={10}>
											{items.map((item) => (
												<Grid item xs={12} key={item.header}>
													<div className={classes.cardListBox}>
														<Avatar
															variant="rounded"
															src={item.image}
															alt="pic"
															imgProps={{
																decoding: "async",
																loading: "lazy",
															}}
															className="pictureCard"
														/>
														<div>
															<div className={classes.cardHeader}>
																{item.header}
															</div>
															<div className={classes.cardDescription}>
																{item.description}
															</div>
															<div className={classes.mt24}>
																<Button
																	size="large"
																	color="primary"
																	variant="contained"
																	disableElevation
																	href={item.buttonLink}
																	className="columnButton"
																>
																	{item.buttonText}
																</Button>
															</div>
														</div>
													</div>
												</Grid>
											))}
										</Grid>
									</Box>
									{(button || buttonSecondary) && (
										<Box
											mt={"60px !important"}
											className={classes.columnButtonsBox}
											textAlign={textAlign}
										>
											{button && (
												<Button
													size="large"
													color="primary"
													variant="contained"
													disableElevation
													href={buttonLink}
													className="columnButton"
												>
													{button}
												</Button>
											)}

											{buttonSecondary && (
												<Button
													size="large"
													color="secondary"
													variant="outlined"
													disableElevation
													href={buttonSecondaryLink}
													className="columnButton"
												>
													{buttonSecondary}
												</Button>
											)}
										</Box>
									)}
								</Box>
							</Grid>
						</Grid>
					</div>
				</Container>
			</section>
		</React.Fragment>
	);
};

export default WebsiteCardList;
